function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M62.6,137.721a1.9,1.9,0,0,1-.967-2.975,4.3,4.3,0,0,0-4.85-6.675,1.9,1.9,0,0,1-2.531-1.839,4.3,4.3,0,0,0-7.847-2.55,1.9,1.9,0,0,1-3.128,0,4.3,4.3,0,0,0-7.847,2.55,1.9,1.9,0,0,1-2.531,1.839,4.3,4.3,0,0,0-4.85,6.675,1.9,1.9,0,0,1-.967,2.975,4.3,4.3,0,0,0,0,8.251,1.9,1.9,0,0,1,.967,2.975,4.3,4.3,0,0,0,4.85,6.675,1.9,1.9,0,0,1,2.531,1.839,4.219,4.219,0,0,0,2.97,4.209,4.457,4.457,0,0,0,1.378.222,4.211,4.211,0,0,0,3.5-1.882,1.9,1.9,0,0,1,3.128,0,4.3,4.3,0,0,0,7.847-2.55,1.9,1.9,0,0,1,2.531-1.839,4.3,4.3,0,0,0,4.85-6.675,1.9,1.9,0,0,1,.967-2.975,4.3,4.3,0,0,0,0-8.251Zm-8.828-.7-9.62,11.224a1.2,1.2,0,0,1-1.634.179l-6.413-4.81a1.2,1.2,0,1,1,1.443-1.924l5.512,4.134,8.887-10.368a1.2,1.2,0,1,1,1.826,1.565Z",
  transform: "translate(-24 -121.801)"
});

function SvgCertifiedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.687,
    height: 40.091,
    viewBox: "0 0 41.687 40.091",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertifiedIcon);
export default __webpack_public_path__ + "static/media/certified-icon.bdd64285.svg";
export { ForwardRef as ReactComponent };